var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm._l(_vm.approvalGroups, function(approvalGroup) {
        return _c("div", { key: approvalGroup.id, staticClass: "form-check" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.selectedApprovalGroupIds,
                expression: "selectedApprovalGroupIds"
              }
            ],
            staticClass: "form-check-input",
            attrs: {
              type: "checkbox",
              id: _vm._uid + "approval" + approvalGroup.id
            },
            domProps: {
              value: approvalGroup.id,
              checked: Array.isArray(_vm.selectedApprovalGroupIds)
                ? _vm._i(_vm.selectedApprovalGroupIds, approvalGroup.id) > -1
                : _vm.selectedApprovalGroupIds
            },
            on: {
              change: function($event) {
                var $$a = _vm.selectedApprovalGroupIds,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = approvalGroup.id,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 &&
                      (_vm.selectedApprovalGroupIds = $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      (_vm.selectedApprovalGroupIds = $$a
                        .slice(0, $$i)
                        .concat($$a.slice($$i + 1)))
                  }
                } else {
                  _vm.selectedApprovalGroupIds = $$c
                }
              }
            }
          }),
          _vm._v(" "),
          _c(
            "label",
            {
              staticClass: "form-check-label",
              attrs: { for: _vm._uid + "approval" + approvalGroup.id }
            },
            [_vm._v("\n      " + _vm._s(approvalGroup.name) + "\n    ")]
          )
        ])
      }),
      _vm._v(" "),
      !_vm.approvalGroups.length
        ? _c("div", [_vm._v("(" + _vm._s(_vm.$t("general.none")) + ")")])
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }